import { AppRootState } from '../../../../store/models/app-state.model';
import { CampaignOverviewModel } from '../../models/campaign-overview.model';

export const getCampaignsSelector = (
  state: AppRootState
): CampaignOverviewModel[] => state.campaignsFeature.campaigns.campaigns;
